import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from '@sprint-expert-manager/app/app.component';
import { appConfig } from '@sprint-expert-manager/app/app.config';
import { register as registerSwiperElements } from 'swiper/element/bundle';

registerSwiperElements();

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
